import API from '@/api/Dashboard'
import MixinFactory from '@/store/mixin'
const Mixin = MixinFactory('Dashboard')

const state = {
  ...Mixin.state,
}

const mutations = {
  ...Mixin.mutations,
}

const actions = {
  fetch: Mixin.actions.fetch(API.get),
}

const getters = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
